import { PostType } from 'src/hook/usePosts'
import {
  EDIT_IMAGE_SIZE,
  EDIT_URL_SIZE,
  EDIT_VIDEO_SIZE,
  MEDIA_MARGIN_TOP,
  postElementsHeight,
  URL_MARGIN_BOTTOM
} from '../../tiptap.constants'
import { GetTextAreaHeightProps } from './getTextAreaHeight.types'

export const baseCalcDefault = `- ${postElementsHeight.default.MODAL_BACK_DROP} - ${postElementsHeight.default.HEADER_SIZE} - ${postElementsHeight.default.TITLE_SIZE} - ${postElementsHeight.default.COUNTER_SIZE} - ${postElementsHeight.default.FOOTER_SIZE}`
export const baseCalcFullScreen = `- ${postElementsHeight.fullscreen.HEADER_SIZE} - ${postElementsHeight.fullscreen.TITLE_SIZE} - ${postElementsHeight.fullscreen.COUNTER_SIZE} - ${postElementsHeight.fullscreen.FOOTER_SIZE}`

const getTextAreaHeight = ({
  isFullScreen,
  isFileUploaded,
  isEdit,
  postType,
  isOpenUpload
}: GetTextAreaHeightProps) => {
  const baseCalc = isFullScreen ? baseCalcFullScreen : baseCalcDefault
  const baseHeights = isFullScreen ? postElementsHeight.fullscreen : postElementsHeight.default

  if (isEdit && PostType.IMAGE === postType) {
    return `calc(100vh ${baseCalc} - ${EDIT_IMAGE_SIZE} - ${MEDIA_MARGIN_TOP});`
  }

  if (isEdit && PostType.VIDEO === postType) {
    return `calc(100vh ${baseCalc} - ${EDIT_VIDEO_SIZE} - ${MEDIA_MARGIN_TOP});`
  }

  if (isEdit && PostType.URL === postType) {
    return `calc(100vh ${baseCalc} - ${EDIT_URL_SIZE} - ${URL_MARGIN_BOTTOM});`
  }

  if (PostType.VIDEO === postType)
    return `calc(100vh ${baseCalc} - ${baseHeights.ACTIONS_VIDEO_SIZE});`

  if (isFileUploaded) return `calc(100vh ${baseCalc} - ${baseHeights.ACTIONS_FILE_UPLOADED_SIZE});`

  if (isOpenUpload) return `calc(100vh ${baseCalc} - ${baseHeights.ACTIONS_OPEN_UPLOAD_SIZE});`

  return `calc(100vh ${baseCalc} - ${baseHeights.ACTIONS_SIZE});`
}

export default getTextAreaHeight
